import { ColorMode, ICustomTheme } from "../types";
import { bigFontSizes, largeFontSizes, normalFontSizes } from "../fontSizes";
import { hugeLettersSpacing, normalLettersSpacing } from "../lettersSpacing";

type State = {
  theme: ICustomTheme;
};

type LightMode = {
  type: "LIGHT_MODE";
};

type DarkMode = {
  type: "DARK_MODE";
};

type FontSizeNormal = {
  type: "FONT_SIZE_NORMAL";
};

type FontSizeBig = {
  type: "FONT_SIZE_BIG";
};

type FontSizeLarge = {
  type: "FONT_SIZE_LARGE";
};

type LetterSpacingNormal = {
  type: "LETTER_SPACING_NORMAL";
};

type LetterSpacingHuge = {
  type: "LETTER_SPACING_HUGE";
};

export type Actions =
  | DarkMode
  | LightMode
  | FontSizeNormal
  | FontSizeBig
  | FontSizeLarge
  | LetterSpacingHuge
  | LetterSpacingNormal;

export const themeConfigurationReducer = (
  state: State,
  action: Actions
): { theme: ICustomTheme } => {
  switch (action.type) {
    case "LIGHT_MODE":
      return {
        theme: { ...state.theme, mode: ColorMode.Light },
      };

    case "DARK_MODE":
      return {
        theme: { ...state.theme, mode: ColorMode.Dark },
      };

    case "FONT_SIZE_NORMAL":
      return {
        theme: { ...state.theme, fontSizes: normalFontSizes },
      };

    case "FONT_SIZE_BIG":
      return {
        theme: { ...state.theme, fontSizes: bigFontSizes },
      };

    case "FONT_SIZE_LARGE":
      return {
        theme: { ...state.theme, fontSizes: largeFontSizes },
      };

    case "LETTER_SPACING_NORMAL":
      return {
        theme: {
          ...state.theme,
          hugeLettersSpacing: false,
          letterSpacings: normalLettersSpacing,
        },
      };

    case "LETTER_SPACING_HUGE":
      return {
        theme: {
          ...state.theme,
          hugeLettersSpacing: true,
          letterSpacings: hugeLettersSpacing,
        },
      };

    default: {
      throw new Error(`Unhandled action type`);
    }
  }
};
